import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { GetExternalLeadResponse } from '../../dto';
import { GetExternalLeadRequest } from '../../dto';

type GetExternalLeadServiceFactoryParams = {
  baseUrl: string;
  httpCall?: IHttpCall;
};

export type GetExternalLeadService = (
  params: GetExternalLeadRequest,
) => Promise<IHttpResponse<GetExternalLeadResponse>>;

export interface GetExternalLeadFunction {
  (
    params: GetExternalLeadServiceFactoryParams,
  ): Promise<IHttpResponse<GetExternalLeadResponse>>;
}

export function getExternalLeadService({
  baseUrl,
  httpCall = fetchBasedCall,
}: GetExternalLeadServiceFactoryParams): GetExternalLeadService {
  return async (params) => {
    const request: IHttpRequest<void> = {
      url: `${baseUrl}/api/v2/leads/`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      queryParams: params,
      schemas: {
        query: GetExternalLeadRequest,
        response: GetExternalLeadResponse,
      },
    };

    return httpCall<void, GetExternalLeadResponse>(request);
  };
}
